/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".banner[_ngcontent-%COMP%]{margin-top:2rem;width:42rem;padding:15px;background-color:#bee3f8;border-radius:6px}@media (max-width:640px){.banner[_ngcontent-%COMP%]{width:auto;margin:15px 10px}}\n/*# sourceMappingURL=message-banner.component.css.map*/"];
export { styles as styles };
